module.exports = __webpack_public_path__ + "static/img/cont49 (5).96a1ce5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont49 (5).jpg
// module id = v/v0
// module chunks = 0